import { Playground } from 'docz';
import { Tabs } from "../../../../../src/components/Elements";
import * as React from 'react';
export default {
  Playground,
  Tabs,
  React
};